import { IExternalAgent } from "../components/ExternalAgents/IExternalAgent";
import Api from "../config/api";


export interface IAxiosExternalAgentsActions {
    data: any[]
}

export class ExternalAgentsActions {
    static get(): Promise<any[]> {
        return Api.get("/external-agents")
            .then((res: IAxiosExternalAgentsActions) => { return res.data })
    }
    static read(id: number): Promise<any[]> {
        return Api.get("/external-agents/" + id)
            .then((res: IAxiosExternalAgentsActions) => { return res.data })
    }
    static create(agent:IExternalAgent): Promise<any[]> {
        return Api.post("/external-agents", agent)
            .then((res: IAxiosExternalAgentsActions) => { return res.data })
    }
    static update(id: number, agent:IExternalAgent): Promise<any[]> {
        return Api.put("/external-agents/" + id, agent)
            .then((res: IAxiosExternalAgentsActions) => { return res.data })
    }
    static delete(id: number): Promise<any[]> {
        return Api.delete("/external-agents/" + id)
            .then((res: IAxiosExternalAgentsActions) => { return res.data })
    }
    static toggle(id: number): Promise<any[]> {
        return Api.get("/external-agents/" + id + "/toggle")
            .then((res: IAxiosExternalAgentsActions) => { return res.data })
    }
    
}